import { Injectable } from '@angular/core';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import * as Excel from 'exceljs/dist/exceljs.min.js';
// import * as logoFile from './carlogo.js';
// import { DatePipe } from '../../node_modules/@angular/common';
import * as _ from 'underscore';
import { DatePipe } from '@angular/common';
import * as moment from 'moment-timezone';

const EXCEL_TYPE =
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

@Injectable({
  providedIn: 'root',
})
export class ExcelService {
  constructor(private datePipe: DatePipe) {}

  public generateExcel(
    dataArr,
    headerArray,
    fromDate,
    toDate,
    selectedType,
    enrollCount,
    totalCount
  ): void {
    const header = headerArray;
    fromDate = new Date();
    toDate = new Date();
    const fromDD = String(fromDate.getDate()).padStart(2, '0');
    const fromMM = String(fromDate.getMonth() + 1).padStart(2, '0'); // January is 0!
    const fromYYYY = fromDate.getFullYear();
    const toDD = String(toDate.getDate()).padStart(2, '0');
    const toMM = String(toDate.getMonth() + 1).padStart(2, '0'); // January is 0!
    const toYYYY = toDate.getFullYear();
    const fromDateFormat = fromMM + fromDD + fromYYYY;
    const toDateFormat = toMM + toDD + toYYYY;

    const data = [];
    for (let i = 0; i < dataArr.length; i++) {
      const arr = [i];
      const valuesArr = _.values(dataArr[i]);
      const concatArr = arr.concat(valuesArr);
      data.push(concatArr);
    }
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(dataArr);
    const workbook: XLSX.WorkBook = {
      Sheets: { data: worksheet },
      SheetNames: ['data'],
    };

    const excelBuffer: any = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'array',
    });

    var excelFileName = '';

    if (selectedType === 'blogs') {
      excelFileName = 'HG_Blog Subscriptions';
    } else {
      // excelFileName = 'hg_reports_';
      excelFileName = 'hg_reports_residential_';
    }

    if(selectedType == "Zipcodes")
    {
      excelFileName = 'hg_reports_zipcode_';
    }

    this.saveAsExcelFile(excelBuffer, excelFileName);
  }
  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], { type: EXCEL_TYPE });
    const currentDate = new Date().getTime();
    FileSaver.saveAs(
      data,
      // fileName + '_' + new Date().getTime() + EXCEL_EXTENSION
      fileName +
        '_' +
        moment(new Date(currentDate)).format('MM/DD/YYYY') +
        EXCEL_EXTENSION
    );
  }

  generateExcel99(
    dataArr,
    headerArray,
    fromDate,
    toDate,
    selectedType,
    enrollCount,
    totalCount
  ) {
    // Excel Title, Header, Data
    const header = headerArray;
    const fromDD = String(fromDate.getDate()).padStart(2, '0');
    const fromMM = String(fromDate.getMonth() + 1).padStart(2, '0'); // January is 0!
    const fromYYYY = fromDate.getFullYear();
    const toDD = String(toDate.getDate()).padStart(2, '0');
    const toMM = String(toDate.getMonth() + 1).padStart(2, '0'); // January is 0!
    const toYYYY = toDate.getFullYear();
    const fromDateFormat = fromMM + fromDD + fromYYYY;
    const toDateFormat = toMM + toDD + toYYYY;

    const data = [];
    for (let i = 0; i < dataArr.length; i++) {
      const arr = [i];
      const valuesArr = _.values(dataArr[i]);
      const concatArr = arr.concat(valuesArr);
      data.push(concatArr);
    }
    // Create workbook and worksheet
    const workbook = new Excel.Workbook();
    const worksheet = workbook.addWorksheet(selectedType);
    console.log('selectedType.....', selectedType);
    console.log(worksheet);
    // Add Row and formatting
    worksheet.addRow(['From']);
    const fromValue = worksheet.getCell('B1');
    fromValue.value = this.datePipe.transform(fromDate, 'MM/dd/yy');
    worksheet.addRow(['To']);
    const toValue = worksheet.getCell('B2');
    toValue.value = this.datePipe.transform(toDate, 'MM/dd/yy');
    worksheet.addRow(['Report Summary']);
    worksheet.addRow(['Usage Type']);
    const usageValue = worksheet.getCell('B4');
    if (selectedType === 'residential') {
      usageValue.value = 'Residential';
    } else if (selectedType === 'commercial') {
      usageValue.value = 'Commercial';
    }
    worksheet.addRow(['No. of Enrolled Users']);
    const enrollCountValue = worksheet.getCell('B5');
    enrollCountValue.value = enrollCount;
    worksheet.addRow(['Total Users']);
    const totalCountValue = worksheet.getCell('B6');
    totalCountValue.value = totalCount;
    // Blank Row
    worksheet.addRow([]);
    // Add Header Row
    const headerRow = worksheet.addRow(header);
    headerRow.font = { bold: true };
    // Cell Style : Fill and Border
    headerRow.eachCell((cell, number) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFF6F6F6' },
      };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };
    });
    // Add Data and Conditional Formatting
    data.forEach((d) => {
      const row = worksheet.addRow(d);
    });
    worksheet.getColumn(3).width = 30;
    worksheet.getColumn(4).width = 30;
    worksheet.addRow([]);
    // Generate Excel File with given name
    console.log('worksheet.....', worksheet);
    console.log('workbook.....', workbook.xlsx.writeBuffer());
    workbook.xlsx.writeBuffer().then((dataObj) => {
      const blob = new Blob([dataObj], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
      });
      console.log('blob is .....', blob);
      FileSaver.saveAs(
        blob,
        'hg_reports_' +
          selectedType +
          '_' +
          fromDateFormat +
          '_to_' +
          toDateFormat +
          EXCEL_EXTENSION
      );
    });
    // workbook.xlsx.writeBuffer().then((dataObj) => {
    //   const blob = new Blob([dataObj], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
    //   console.log("blob is .....",blob);
    //   FileSaver.saveAs(blob, 'hg_reports_' + selectedType + '_' + fromDateFormat + '_to_' + toDateFormat + EXCEL_EXTENSION);
    // });
  }
}
